import React, { useState } from 'react';
import { Button, DialogContentText } from '@mui/material';

import { Dialog } from '@paragon/popup-state';

import { addSelectedToBatch, createBatchFromSelected } from '../../../actions/batchActions';
import { getBatchCreationOrAdditionWouldHaveMixedThicknesses } from '../../../selectors/productionGroupGrid';
import { useAppDispatch, useAppSelector } from '../../hooks';

export function CreateOrAddToBatchButton() {
  const dispatch = useAppDispatch();
  const checkedAnalysisSetGuids = useAppSelector((state) => state.batchesAndBundlesTab.checkedAnalysisSetGuids);
  const batchBeingEditedGuid = useAppSelector((state) => state.batchesAndBundlesTab.batchBeingEditedGuid);
  const checkedTrussesHaveMixedThicknesses = useAppSelector(getBatchCreationOrAdditionWouldHaveMixedThicknesses);
  const [confirmMixedThicknessesOpen, setConfirmMixedThicknessesOpen] = useState(false);
  function createOrAddToBatch() {
    batchBeingEditedGuid ? dispatch(addSelectedToBatch()) : dispatch(createBatchFromSelected());
  }

  return (
    <>
      <Button
        variant="outlined"
        sx={{ mr: 1 }}
        onClick={() =>
          checkedTrussesHaveMixedThicknesses ? void setConfirmMixedThicknessesOpen(true) : void createOrAddToBatch()
        }
        disabled={checkedAnalysisSetGuids.length === 0}
      >
        {batchBeingEditedGuid ? 'Add checked to Batch' : 'Create Batch'}
      </Button>
      <Dialog
        open={confirmMixedThicknessesOpen}
        title="Confirm mixed thicknesses"
        onSubmit={() => {
          setConfirmMixedThicknessesOpen(false);
          createOrAddToBatch();
        }}
        onCancel={() => void setConfirmMixedThicknessesOpen(false)}
        enterKeySubmits
      >
        <DialogContentText>The selected trusses are mixed thicknesses. Do you want to continue?</DialogContentText>
      </Dialog>
    </>
  );
}
